import { localDatabaseUrls } from "../backend/constants";
import { getJWTToken } from "../shared/fetchWrapper/fetchWrapper";
import { postAPI } from "../backend/commons";
import AlertManager from "../shared/Alert/Alert";

const UPLOAD_CONFIG = {
  VENDOR: {
    path: "VENDOR",
  },
  ITE_VIEW: {
    path: "ITE_VIEW",
  },
  ANTIDUMPING: {
    path: "ANTIDUMPING",
  },
  SKUEXCLUSION: {
    path: "SKUEXCLUSION",
  },
  TARIFF: {
    path: "TARIFF",
  },
  CONTAINER: {
    path: "CONTAINER",
  },
};

const buildUploadConfig = (uploadType) => {
  if (!uploadType) {
    return null;
  }
  const normalizedType = String(uploadType).toUpperCase();
  return UPLOAD_CONFIG[normalizedType] ?? null;
};

export const uploadLandedCostFile = async ({ file, uploadType }) => {
  const config = buildUploadConfig(uploadType);
  if (!file || !config) {
    AlertManager.error("Unsupported landed cost upload request.", { contactSupport: false });
    return null;
  }

  const tokenInfo = await getJWTToken();
  if (!tokenInfo) {
    window.location.href = "/";
    return null;
  }

  const formData = new FormData();
  formData.append("file", file);
  const shouldIncludeUser = ["VENDOR", "SKUEXCLUSION", "ANTIDUMPING", "TARIFF", "CONTAINER"].includes(config.path);
  if (shouldIncludeUser && tokenInfo?.username) {
    formData.append("uploadedUser", tokenInfo.username);
  }

  const apiUrl = `${localDatabaseUrls.baseURL}${localDatabaseUrls.serviceURL.landedCostUploadBase}${config.path}`;
  return postAPI(apiUrl, formData, tokenInfo);
};

export default uploadLandedCostFile;
